import React from 'react';
import { Server } from 'shared-types';

interface ServerListEditorProps {
    servers: Server[];
    onChange: (newServers: Server[]) => void;
}

const ServerListEditor: React.FC<ServerListEditorProps> = ({ servers, onChange }) => {

    const handleItemChange = (index: number, field: keyof Server, value: any) => {
        const newServers = [...servers];
        // @ts-ignore
        newServers[index][field] = value;
        onChange(newServers);
    };

    const handleAddItem = () => {
        const newItem: Server = {
            id: `server_${Date.now()}`,
            name: 'New Server',
            city: 'City',
            country: 'Country',
            location: 'City, Country',
            url: 'https://speed.example.com/100MB.bin',
            isSponsored: false,
        };
        onChange([...servers, newItem]);
    };
    
    const handleRemoveItem = (index: number) => {
        const newServers = servers.filter((_, i) => i !== index);
        onChange(newServers);
    };

    return (
        <div className="space-y-4">
            {servers.map((server, index) => (
                <div key={server.id} className="p-4 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700 space-y-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                             <label className="text-xs font-medium text-slate-500">Name</label>
                             <input type="text" value={server.name} onChange={e => handleItemChange(index, 'name', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
                        </div>
                        <div>
                            <label className="text-xs font-medium text-slate-500">Location</label>
                             <input type="text" value={server.location} onChange={e => handleItemChange(index, 'location', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
                        </div>
                    </div>
                     <div>
                        <label className="text-xs font-medium text-slate-500">URL</label>
                        <input type="text" value={server.url} onChange={e => handleItemChange(index, 'url', e.target.value)} className="w-full bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-md p-2 text-sm mt-1" />
                    </div>
                    <div className="flex justify-between items-center pt-2">
                        <label className="flex items-center gap-2 text-sm cursor-pointer">
                            <input type="checkbox" checked={server.isSponsored} onChange={e => handleItemChange(index, 'isSponsored', e.target.checked)} className="h-4 w-4 rounded text-cyan-600 focus:ring-cyan-500" />
                            Sponsored
                        </label>
                         <button onClick={() => handleRemoveItem(index)} className="px-3 py-2 bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 text-sm font-semibold rounded-md hover:bg-red-200 dark:hover:bg-red-900/60 transition">Remove</button>
                    </div>
                </div>
            ))}
            <button onClick={handleAddItem} className="px-4 py-2 bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40 dark:text-cyan-300 text-sm font-semibold rounded-full hover:bg-cyan-200 dark:hover:bg-cyan-900/60 transition">
                + Add Server
            </button>
        </div>
    );
};

export default ServerListEditor;